<template>
  <div class="w-fit rounded-full border border-grey-900/50">
    <div
      class="badge-shadow-emboss z-10 flex items-center gap-1.5 rounded-full py-1.5 text-xs font-bold uppercase leading-3 tracking-wide text-grey-900"
      :class="[currentTheme, label ? 'px-2' : 'px-1.5']"
    >
      <component
        :is="icon"
        class="h-3 w-3 shrink-0"
        :class="theme === 'green-on-dark' ? 'fill-white' : 'fill-grey-900'"
        width="12"
        height="12"
      />
      <span v-if="label">{{ label }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  icon: Component | string;
  theme: BadgeTheme;
  label?: string;
}>();

export type BadgeTheme =
  | "green"
  | "green-on-dark"
  | "jag"
  | "lemon"
  | "rose"
  | "sky"
  | "grey";

const themeColours: Record<BadgeTheme, string> = {
  green: "bg-green-100",
  "green-on-dark": "bg-green-700 text-white",
  jag: "bg-jag-100",
  lemon: "bg-lemon-100",
  rose: "bg-rose-100",
  sky: "bg-sky-100",
  grey: "bg-grey-100",
};

const currentTheme = computed(() => themeColours[props.theme]);
</script>

<style scoped>
.badge-shadow-emboss {
  box-shadow:
    0px -1px 2px -1px rgba(0, 0, 0, 0.3) inset,
    0px 1px 2px -1px rgba(255, 255, 255, 0.4) inset;
}
</style>
